export default "__VITE_ASSET__B6SrtB6e__"